export const style = {
  default: {
    cursor: 'pointer',
  },

  columnStyle: {
    lineHeight: '29px',
    height: '29px',
    minWidth: '30px',
    maxWidth: '30px',
    cursor: 'pointer'
  },

  iconStack: {
    lineHeight: '29px',
  }
};

export const iconStack = {
  iconStack1x: {
    position: 'absolute',
    left: '0',
    width: '100%',
    textAlign: 'center',
    lineHeight: 'inherit'
  },

  iconStack3x: {
    position: 'absolute',
    left: '0',
    width: '100%',
    textAlign: 'center',
    fontSize: '2em'
  }
};

export const materialIcons = {
  materialIcon: {
    fontSize: '28px',
    lineHeight: '8px'
  }
}



// WEBPACK FOOTER //
// ./src/сomponents/TableHandler/style.js